import Axios from 'axios'
import { API_URL } from '@app/constants/endpoints'

const ENDPOINT = `${API_URL}/api/energy/billing_periods/current`

const convertDate = (currentTime: Date): string => currentTime.toISOString()

const fetchBillingCurrentStats = (currentTime: Date, accessToken: string) => Axios.get(ENDPOINT, {
  params: { current_time: convertDate(currentTime) },
  headers: {
    'Access-Token': accessToken,
  },
})

export default {
  fetchBillingCurrentStats,
}
